export type ProfileStep = 'photo' | 'prompt';

// The ONE thing the profile screen suggests next (issue #245): a photo first
// (private until a mutual reveal, it is what makes you recognisable then),
// then a prompt (something for a neighbour to reply to). Required fields
// are not here: the profile cannot be saved without them. Bio waits until
// the screen can edit it.
export function nextProfileStep({
  photoCount,
  promptCount,
}: {
  photoCount: number;
  promptCount: number;
}): ProfileStep | null {
  if (photoCount === 0) return 'photo';
  if (promptCount === 0) return 'prompt';

  return null;
}

// A dismissed step stays dismissed; the nudge returns only when the step
// changes (the photo was added, so the prompt is next), never as a nag.
export function shouldShowNudge(step: ProfileStep | null, dismissed: string | undefined): boolean {
  return step !== null && step !== dismissed;
}

export function nudgeCopy(step: ProfileStep): { text: string; action: string } {
  return step === 'photo'
    ? {
        text: 'Add a photo so people recognize you after you both reveal. It stays private until then.',
        action: 'Add photo',
      }
    : { text: 'Answer a prompt to give neighbors something to talk about.', action: 'Choose a prompt' };
}
